import {downloadFile} from '@assets/components/filemanager/src/helper';

$(document).on('click', '.psevdo_href', function () {
    const btn = $(this);
    const fileId = btn.data('file-id');
    const isSveden = true;
    downloadFile(fileId, isSveden);
});
